"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ViewButtonsContainer = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const ViewButtonsContainer = (props) => {
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ ref: props.innerRef, className: 'view-buttons flex justify-content-end' + (props.className ? ' ' + props.className : ''), style: { height: '6%' } }, { children: [props.flex &&
                (0, jsx_runtime_1.jsx)("div", Object.assign({ className: 'flex' }, { children: props.children })), !props.flex &&
                props.children] })));
};
exports.ViewButtonsContainer = ViewButtonsContainer;
